module.exports = __webpack_public_path__ + "img/15.da3f4a52.svg";